<div class="dialog">
  <h1 mat-dialog-title>Import and export</h1>
  <div mat-dialog-content class="dialog-content">
    <div *ngIf="eventDataImportOptions.length > 0">
      <p class="text-center"><b>Event data</b></p>

      <div class="row centered">
        <ng-container
          *ngFor="let eventDataImportOption of eventDataOptionsWithHandler"
        >
          <input
            #eventDataFileInput
            type="file"
            tabindex="-1"
            class="file-input"
            [accept]="eventDataImportOption.accept"
            (change)="eventDataImportOption.handler($event.target.files)"
          />
          <button
            class="file-input-button"
            (click)="eventDataFileInput.click()"
          >
            <img src="assets/icons/eventData.svg" alt="Event data icon" />
            Load {{ eventDataImportOption.fileType }}
          </button>
        </ng-container>
      </div>
    </div>

    <p class="text-center"><b>Geometries</b></p>

    <div class="row centered">
      <input
        #objFileInput
        type="file"
        tabindex="-1"
        class="file-input"
        accept=".obj"
        name="image"
        (change)="handleOBJInput($event.target.files)"
      />
      <button class="file-input-button" (click)="objFileInput.click()">
        <img src="assets/icons/obj.svg" alt="" /> Load .obj
      </button>

      <input
        #gltfFileInput
        type="file"
        tabindex="-1"
        class="file-input"
        accept=".gltf,.glb,.gltf.zip,.glb.zip"
        name="image"
        (change)="handleGLTFInput($event.target.files)"
      />
      <button class="file-input-button" (click)="gltfFileInput.click()">
        <img src="assets/icons/gltf.svg" alt="" /> Load .gltf/.glb
      </button>

      <input
        #rootFileInput
        type="file"
        tabindex="-1"
        class="file-input"
        accept=".root"
        (change)="handleROOTInput($event.target.files)"
      />
      <button class="file-input-button" (click)="rootFileInput.click()">
        <img src="assets/icons/file-import.svg" alt="" /> Load .root
      </button>

      <input
        #rootJSONFileInput
        type="file"
        tabindex="-1"
        class="file-input"
        accept=".json.gz"
        (change)="handleRootJSONInput($event.target.files)"
      />
      <button class="file-input-button" (click)="rootJSONFileInput.click()">
        <img src="assets/icons/file-import.svg" alt="" /> Load .json.gz
      </button>
    </div>

    <p class="text-center"><b>Scene</b></p>

    <div class="row centered">
      <button
        class="file-input-button load-export"
        id="exportScene"
        (click)="saveScene()"
      >
        <img src="assets/icons/save.svg" alt="" /> Save scene
      </button>

      <input
        #loadSceneInput
        type="file"
        tabindex="-1"
        class="file-input"
        accept=".phnx"
        name="image"
        (change)="handlePhoenixInput($event.target.files)"
      />
      <button
        class="file-input-button load-export"
        id="importScene"
        (click)="loadSceneInput.click()"
      >
        <img src="assets/icons/upload.svg" alt="" /> Load scene
      </button>

      <button
        class="file-input-button export-button"
        id="exportOBJ"
        (click)="exportOBJ()"
      >
        <img src="assets/icons/obj.svg" alt="" /> Save OBJ
      </button>
    </div>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="onClose()" cdkFocusInitial>
      Close
    </button>
  </div>
</div>
